import React from 'react';
import { Loader } from 'components/common_v2/loaders';
import PropTypes from 'prop-types';

const InlineLoader = ({ size }) => <Loader active inline size={size} />;

InlineLoader.propTypes = {
  size: PropTypes.string,
};

InlineLoader.defaultProps = {
  size: 'small',
};

export default InlineLoader;
